import { render, staticRenderFns } from "./ModalHighlightWidget.vue?vue&type=template&id=57a34044&scoped=true&"
import script from "./ModalHighlightWidget.vue?vue&type=script&lang=js&"
export * from "./ModalHighlightWidget.vue?vue&type=script&lang=js&"
import style0 from "./ModalHighlightWidget.vue?vue&type=style&index=0&id=57a34044&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a34044",
  null
  
)

export default component.exports